import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from './../../../utilities/validation/validator';
import lodash from 'lodash';
import ProviderManager from '../../../provider/providerManager';

export const doCallBack = createAsyncThunk('callBackBlock/doCallBack', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('doCallBack', [data.form.id, data.form.phone, data.form.subject]);
    return {isSuccess: result.Body.isSuccess , errorCode: 0};
  } catch (error) {
    return {isSuccess: false , errorCode: error.errorCode};
  }
});

const CallBackBlockSlice = createSlice({
  name: 'callBackBlock',
  initialState: {
    form: {
      id: '',
      phone: '',
      subject: '',
      valid: '',
      errors: {
        id: '',
        phone: '',
        subjects: '',
      },
      rules: {
        subject: {
          required: {value: true, error: 'אנא בחר נושא פנייה'},
        },
      },
    },
    isSuccess: false,
    showResponse: false,
    errorCode: 0
  },
  reducers: {
    setShowResponse: (state, action) => {
      state.showResponse = action.payload;
    },
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    clearIsValid: {
      reducer(state, action) {
        state.form = action.payload;

      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.valid = '';
        return {payload: form};
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
  },
  extraReducers: {
    [doCallBack.fulfilled]: (state, action) => {
      state.isSuccess = action.payload.isSuccess;
      state.errorCode = action.payload.errorCode;
      state.showResponse = true;
    },
  },
});

export const {changeHandler, setPopUp, clearIsValid, validateHandler, setShowResponse} = CallBackBlockSlice.actions;

export default CallBackBlockSlice.reducer;
